export default (url, token, params) => {
    const time = new Date().getTime();
    const urlParams = Object.assign(params || {});
    urlParams.t = time;
    if (token) {
        urlParams.access_token = token;
    }
    const urlParamsStr = Object.entries(urlParams)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
    window.open(`${url}?${urlParamsStr}`);
};

/**
 * Получает файл с сервера как Blob, не открывая окно загрузки
 * @param {string} url - базовый URL для запроса
 * @param {string|null} token - access_token (если нужен)
 * @param {object} params - дополнительные GET-параметры
 * @returns {Promise<Blob>} - Promise, который разрешается в Blob с содержимым файла
 */
export const fetchFileBlob = async (url, token, params = {}) => {
    const time = Date.now();
    // объединяем параметры, добавляем временную метку и токен
    const urlParams = { ...params, t: time };
    if (token) {
        urlParams.access_token = token;
    }

    // формируем строку параметров с правильным кодированием
    const urlParamsStr = Object.entries(urlParams)
        .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        .join('&');

    const fullUrl = `${url}?${urlParamsStr}`;

    const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
            // например: 'X-Requested-With': 'XMLHttpRequest'
        }
    });

    if (!response.ok) {
        throw new Error(`Ошибка загрузки файла: ${response.status} ${response.statusText}`);
    }

    // возвращаем Blob с файлом
    return await response.blob();
};
